const DEFAULT_OPENID_SCOPES: readonly string[] = ["openid", "profile", "offline_access"];

const splitScopes = (scopeString: string): string[] =>
	scopeString
		.split(/[,\s]+/)
		.map((scope: string) => scope.trim())
		.filter((scope: string) => scope.length > 0);

export const getAuthScopes = (configuredScopes: string | undefined): string[] => {
	if (configuredScopes === undefined || configuredScopes.trim().length === 0) {
		return [...DEFAULT_OPENID_SCOPES];
	}

	return splitScopes(configuredScopes);
};

export const getSingleScope = (configuredScope: string | undefined, fallback: string): string => {
	if (configuredScope === undefined || configuredScope.trim().length === 0) {
		return fallback;
	}

	const scopes = splitScopes(configuredScope);
	return scopes[0] ?? fallback;
};
